import { FileType } from 'ant-design-vue/es/upload/interface'
/**
 * File 转 Base64
 * @param file     {File}   file
 * @return {Promise<String>}
 */
export function fileToBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.addEventListener('load', (evt) => resolve(evt.target!.result))
    reader.addEventListener('error', reject)
    reader.readAsDataURL(file)
  })
}

export function formatFileSize(size: number) {
  if (size < 1024) {
    return `${size}Bytes`
  } else if (size < 1024 * 1024) {
    return `${(size / 1024).toFixed(0)}KB`
  } else if (size < 1024 * 1024 * 1024) {
    return `${(size / 1024 / 1024).toFixed(0)}MB`
  } else {
    return `${(size / 1024 / 1024 / 1024).toFixed(0)}GB`
  }
}

/**
 * @description: base64 to blob
 */
export function dataURLtoBlob(base64Buf: string): Blob {
  const arr = base64Buf.split(',')
  const typeItem = arr[0]
  const mime = typeItem.match(/:(.*?);/)![1]
  const bstr = window.atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

/**
 * 匹配文件类型是否符合 accept 规则
 * @param file 文件对象
 * @param accept accept 字符串，支持多种格式用逗号分隔
 * @returns 是否匹配
 */
export const matchAcceptType = (file: FileType, accept: string): boolean => {
  if (!accept) return true
  
  const fileName = file.name.toLowerCase()
  const fileType = file.type.toLowerCase()
  
  // 将 accept 按逗号分割，并去除空格
  const acceptTypes = accept.toLowerCase().split(',').map(type => type.trim())
  
  return acceptTypes.some(acceptType => {
    // 处理文件扩展名格式 (.pdf, .doc, .docx 等)
    if (acceptType.startsWith('.')) {
      return fileName.endsWith(acceptType)
    }
    
    // 处理通配符 MIME 类型 (image/*, video/*, audio/*)
    if (acceptType.includes('/*')) {
      const [mainType] = acceptType.split('/')
      const [fileMainType] = fileType.split('/')
      return mainType === fileMainType
    }
    
    // 处理具体的 MIME 类型
    if (acceptType.includes('/')) {
      return fileType === acceptType
    }
    
    // 处理没有点的扩展名格式 (pdf, doc, docx 等)
    return fileName.endsWith(`.${acceptType}`)
  })
}